import { useState } from 'react';

import { DealIdsByType } from 'interfaces';
import { selectIsAdmin } from 'modules/current-user/selectors';
import { deleteDeal, deleteDeals } from 'modules/deals/action';
import { deleteExternalShareExchange, deleteExternalShareExchanges } from 'modules/external-share-exchange/action';
import { useAppDispatch, useAppSelector } from 'modules/store';

import useModal, { UseModalReturnValues } from '../use-modal/useModal';

const useDeleteDealsByType = ({
  onSuccess,
}: {
  onSuccess?: VoidFunction;
}): [typeof handleDeleteDealsByType, UseModalReturnValues, boolean] => {
  const dispatch = useAppDispatch();

  const modalProps = useModal();

  const isAdmin = useAppSelector(selectIsAdmin);

  const [isLoading, setIsLoading] = useState(false);

  const handleDeleteDealsByType = (payload: DealIdsByType) => {
    setIsLoading(true);

    const allActions: Promise<unknown>[] = [];

    if (payload.internal.length) {
      if (payload.internal.length === 1) {
        allActions.push(dispatch(deleteDeal({ id: payload.internal[0], isAdmin })).unwrap());
      } else {
        allActions.push(dispatch(deleteDeals({ dealsIds: payload.internal, isAdmin })).unwrap());
      }
    }
    if (payload.external.length) {
      if (payload.external.length === 1) {
        allActions.push(dispatch(deleteExternalShareExchange({ id: payload.external[0], isAdmin })).unwrap());
      } else {
        allActions.push(dispatch(deleteExternalShareExchanges({ ids: payload.external, isAdmin })).unwrap());
      }
    }

    if (allActions.length === 0) {
      allActions.push(Promise.resolve());
    }

    const promise = Promise.all(allActions);

    promise.then(onSuccess).finally(() => {
      setIsLoading(false);
      modalProps.onClose();
    });
  };

  return [handleDeleteDealsByType, modalProps, isLoading];
};

export default useDeleteDealsByType;
